<script>
  export let min;
  export let max;
  export let numberValue;
  export let label;
  export let step;
  export let disabled;
</script>

<div class="slider-container">
  <label>{label}</label>
  <input type="range" bind:value={numberValue} {min} {max} {step} {disabled} />
  <input type="number" bind:value={numberValue} {min} {max} {step} {disabled} />
</div>

<style>
  input,
  label {
    display: inline-block;
    vertical-align: middle;
  }
  label {
    width: 100px;
  }
  .slider-container {
    margin-bottom: 4px;
  }
</style>
